module.exports = __webpack_public_path__ + "img/10.34632b93.jpg";